export const TEXTS = {
  MARKETING_MAIL_AGREEMENT_CHECKBOX_LABEL: 'Я даю согласие на ',
  MARKETING_MAIL_AGREEMENT_CHECKBOX_LINK_TEXT: 'получение рекламных материалов и рассылок',
};
